var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"solution"},[_c('Header'),_c('Navigation'),_c('ApplicationScenario'),_c('RemoteBank'),_c('DigitalCustomerService'),_c('CallCenter'),_c('MedicalEquipment'),_c('OtherScenes'),_c('SystemFunction'),_c('SchemeAdvantages'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }